import React, { Component } from 'react';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Actualiza el estado para que el siguiente renderizado muestre la interfaz de respaldo.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // También puedes registrar el error en un servicio de reporte de errores
    console.error("Capturado un error:", error, errorInfo);
    this.setState({ errorInfo });
  }

  render() {
    if (this.state.hasError) {
      // Puedes renderizar cualquier interfaz de respaldo personalizada
      return (
        <div>
          <h1>Algo salió mal.</h1>
          {/* En un entorno de producción, puedes renderizar aquí detalles del error solo para desarrolladores */}
          {/* <details>
            {this.state.errorInfo && this.state.errorInfo.componentStack.toString()}
          </details> */}
        </div>
      );
    }

    return this.props.children; 
  }
}

export default ErrorBoundary;
